/**
 * @voltxampere/ui — Avalanche diode (Sprint 45-4, placeholder)
 *
 * PLACEHOLDER. Yüksek-voltaj breakdown — `zener` schemaType + high
 * V_BR. Gerçek avalanche multiplication (M-factor) + temperature
 * coefficient + dark current Sprint 50+ engine extension #4 ile.
 *
 * Reference: Generic avalanche diode (e.g. SAES Getters APD,
 * Hamamatsu APD modules). V_BR 100-2000 V (avalanche region),
 * gain (M) 100-1000. Çok-yüksek hassasiyetli foton sayma (single-
 * photon detector SPAD), CT scan x-ray detector, optical fiber
 * receiver. Geiger mode'da sayım yapar.
 *
 *   Default mapping → zener schemaType:
 *     saturationCurrent = 1e-13
 *     ideality = 1.2
 *     breakdownVoltage = 100  (high-voltage avalanche)
 *
 * Engine zero-diff invariant honored — canonical `zener` engine
 * type via schemaType.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { zener } from "../zener.js";
export const diodeAvalanche = {
    id: "avalanche-diode",
    nameTr: "Avalanche Diode 100V (APD, placeholder)",
    nameEn: "Avalanche Diode 100V (APD, placeholder)",
    shortcut: "D",
    category: "active",
    viewBox: zener.viewBox,
    terminals: zener.terminals,
    defaultLabel: "D",
    defaultValue: "APD",
    schemaType: "zener",
    defaultParams: { saturationCurrent: 1e-13, ideality: 1.2, breakdownVoltage: 100 },
    renderSVG: () => zener.renderSVG(),
};
//# sourceMappingURL=diode-avalanche.js.map